import React from "react"
import { Badge } from "src/components/ui/badge"
import { useLeadStatuses } from "src/features/leads/hooks/useLeadStatuses"

const FALLBACK_COLOR = "#94a3b8"

export function LeadStatusBadge({ status }) {
  const { statuses } = useLeadStatuses()

  if (!status) return null

  const stage = statuses.find((s) => s.value === status)
  const label = stage?.label || status
  const color = stage?.color || FALLBACK_COLOR

  return (
    <Badge variant="outline" className="gap-1.5 font-normal">
      <span className="h-1.5 w-1.5 rounded-full shrink-0" style={{ backgroundColor: color }} />
      {label}
    </Badge>
  )
}
